/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { PureComponent, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

export class Portal extends PureComponent<any, any> {
  state = {
    targetElement: null as any, // The DOM node that the portal mounts in
  };

  static propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  };

  componentDidMount() {
    // This happens only on the client side
    const { id } = this.props;
    const targetElement = document.getElementById(id);
    this.setState(() => ({ targetElement }));
  }

  render() {
    const { targetElement } = this.state;
    const { children } = this.props;
    return targetElement && createPortal(children, targetElement);
  }
}

/**
 * This component will remove the existing DOM content in {container} and then
 * portal it's {children} into {container}.
 * The removing of the existing DOM content is required because
 * ReactDOM.createPortal does not do this, whereas ReactDOM.render does.
 */
export const ReplacingPortal = ({ container, children }: any) => {
  const [innerHtmlEmptied, setInnerHtmlEmptied] = useState(false);
  useLayoutEffect(() => {
    if (!innerHtmlEmptied) {
      // eslint-disable-next-line no-param-reassign
      container.innerHTML = '';
      setInnerHtmlEmptied(true);
    }
  }, [innerHtmlEmptied]);
  if (!innerHtmlEmptied) {
    return null;
  }
  return createPortal(<>{children}</>, container);
};
